import { takeLatest, put } from 'redux-saga/effects'
import * as CONST from './const'
import * as ERRORS from 'Reducers/Errors/const'
import { apiClient } from 'Module/API/Client'
import NProgress from 'nprogress'
import { callApi } from '../apiCall'
import { getCities as getCitiesGQL } from '../../Module/graphQL'
import { normalizeGraphQLConnection } from '../../shared/graphql/utils'

/**
 * Get city pickup time
 *
 * @param cityId
 */
function* getCityPickupTime(action) {
  NProgress.start()
  const response = yield callApi(apiClient.getCityPickupTime, action.cityId)
  const body = yield response.json()

  try {
    if (response.ok) {
      yield put({
        type: CONST.GET_CITY_PICKUP_TIME_SUCCESS,
        payload: {
          cityPickupTime: body,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: body,
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Create city pickup time
 *
 * @param cityId
 * @param payload
 */
function* createCityPickupTime(action) {
  NProgress.start()
  const { values, resolve, reject } = action.payload

  const response = yield callApi(
    apiClient.createCityPickupTime,
    action.cityId,
    values,
  )
  const body = yield response.json()

  try {
    if (response.ok) {
      resolve(body)
      yield put({
        type: CONST.CREATE_CITY_PICKUP_TIME_SUCCESS,
        payload: body,
      })
    } else {
      reject()
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: body,
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Get cities
 *
 * @param {Object} action
 */
function* getCities(action) {
  NProgress.start()
  const response = yield callApi(getCitiesGQL)
  const body = yield response.json()

  if (body.errors) {
    yield put({
      type: CONST.CITY_GET_CITIES_ERROR,
      payload: {
        errorMessage: body.errors[0].message,
      },
    })
  } else {
    yield put({
      type: CONST.CITY_GET_CITIES_SUCCESS,
      payload: {
        cities: normalizeGraphQLConnection(body.data.cities),
      },
    })
  }

  NProgress.done()
}

/**
 * Get city pickup time
 */
export function* watchGetCityPickupTime() {
  yield takeLatest(CONST.GET_CITY_PICKUP_TIME, getCityPickupTime)
}

/**
 * Create city pickup time
 */
export function* watchCreateCityPickupTime() {
  yield takeLatest(CONST.CREATE_CITY_PICKUP_TIME, createCityPickupTime)
}

/**
 * Login user watcher
 */
export function* watchGetCities() {
  yield takeLatest(CONST.CITY_GET_CITIES, getCities)
}



// WEBPACK FOOTER //
// ./src/Reducers/City/sagas.js